import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  timerParent: {
    margin: "15px 1rem 0 1rem",
    backgroundColor: "#ffffff",
    height: "auto",
    borderRadius: "12px",
    "@media (max-width:992px)": {
      flexDirection: "column-reverse",
    },
  },
  activeButton: {
    width: "100%",
    height: "50%",
    borderTopLeftRadius: "12px",
    fontSize: "10px",
    border: "none",
    cursor: "pointer",
    "@media (max-width:992px)": {
      position: "relative",
      width: "50%",
      top: "11px",
      borderTopLeftRadius: "0",
      borderBottomLeftRadius: "12px",
    },
  },
  inActiveButton: {
    width: "100%",
    height: "50%",
    borderBottomLeftRadius: "12px",
    fontSize: "10px",
    border: "none",
    cursor: "pointer",
    "@media (max-width:992px)": {
      width: "50%",
      position: "relative",
      top: "11px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "12px",
    },
  },
  activeBgColor: {
    backgroundColor: "#FFAF4A",
  },
  iconSize: {
    fontSize: "20px",
    marginTop: "5px",
  },
  btnText: {
    marginTop: "0",
  },
  timerInputParent: {
    padding: "5px 35px",
    height:'inherit',
    "@media (min-width:992px) and (max-width:1048px)": {
      padding: "5px 5px",
    },
    "@media (max-width:600px)": {
      padding: "5px ",
    },
  },
  dayTimeBox: {
    height:'100%',
    display:'flex',
    justifyContent:"center",
    flexDirection:'column',
  },
  dayBox: {
    fontSize:'1.3rem',
    color:'#A3A3A3'
  },
  timeBox: {
    fontSize:'1.7rem',
    color:'#FFBA45',
    fontWeight:700
  },
  clockInParent: {
    padding: "8px 8px 12px 8px",
    width: "100%",
  },
  clockInBtn: {
    width: "100%",
    backgroundColor: "#000000",
    color: "#ffffff",
    fontSize: "11px",
    padding: "8px 0",
    borderRadius: "7px",
    textTransform: "capitalize",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#000000",
    },
  },
  clockParent: {
    textAlign: "center",
    borderLeft: "1px solid #E5E5E5",
    "@media (max-width:992px)": {
      borderLeft: "none",
    },
  },
  hoursWorked: {
    color: "#A3A3A3",
    fontWeight: "normal",
    margin: "10px 0 2px 0",
    "@media (min-width:992px) and (max-width:1048px)": {
      margin: "10px 0 6px 0",
    },
  },
  countTimer: {
    margin: "0 0 9px 0",
    "@media (min-width:992px) and (max-width:1048px)": {
      fontSize: "larger",
      margin: "0 0 14px 0",
    },
  },
  breakTimer: {
    margin: "10px 0 9px 0",
    color: "#039855",
    fontSize:"12px",
    "@media (max-width:992px)": {
      margin: "8px 0 0 0",
    },
    // "@media (min-width:992px) and (max-width:1048px)": {
    //   fontSize: "11px",
    //   margin: "0 0 14px 0",
    // },
  },
  clockOutBtn: {
    width: "50%",
    backgroundColor: "#000000",
    color: "#ffffff",
    fontSize: "11px",
    padding: "8px 0",
    borderRadius: "7px",
    cursor: "pointer",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#000000",
    },
    "@media (min-width:320px) and (max-width:600px)": {
      width: "100%",
    },
    "@media (min-width:600px) and (max-width:768px)": {
      width: "90%",
    },
    "@media (min-width:768px) and (max-width:992px)": {
      width: "90%",
    },
  },
}));

export default useStyles;
